export const RESET_BOOKING = 'RESET_BOOKING'

export default () => ({
  type: RESET_BOOKING,
})
